export default __webpack_public_path__ + "static/media/guest_15_02.ce3f0844.png";